import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/orbit/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { status } = useAuth();
  const location = useLocation();

  if (status === "checking") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50" data-testid="orbit-loading">
        <Loader2 className="w-6 h-6 animate-spin text-slate-500" />
      </div>
    );
  }
  if (status !== "authenticated") {
    return <Navigate to="/orbit/login" state={{ from: location.pathname }} replace />;
  }
  return children;
}
